// 'CAB.LIN[50]' -> 50
// 'CAB.LIN[]' -> 0

export function _findIndex(str = '') {
  return parseInt((/\[(.*)\]/.exec(str) || [])[1]) || 0;
}
